const footerLinks = [
  { label: "Privacy Policy", href: "https://www.marrsinglife.com/privacy-policy" },
  { label: "Terms of Use", href: "https://www.marrsinglife.com/terms-and-conditions" },
  { label: "Contact", href: "/contact" },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      style={{
        background: "var(--mc-text)",
        padding: "56px 32px 44px",
        color: "rgba(255,255,255,0.6)",
        fontSize: 12.5,
        letterSpacing: "0.04em",
        textAlign: "center",
      }}
    >
      <div style={{ maxWidth: 640, margin: "0 auto", display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
        <div className="font-serif" data-testid="footer-brand" style={{ fontSize: 22, fontWeight: 500, color: "white" }}>
          Marrsing<span style={{ color: "var(--mc-blue-light)" }}>Clause</span>
          <sup style={{ fontSize: 10, opacity: 0.7, marginLeft: 1 }}>®</sup>
        </div>

        <p className="font-serif" style={{ fontStyle: "italic", fontSize: 15, color: "rgba(255,255,255,0.75)", margin: 0 }}>
          A Relationship Intelligence Alignment System™
        </p>

        <p className="font-mono" style={{ fontSize: 11, letterSpacing: "0.16em", textTransform: "uppercase", color: "var(--mc-blue-light)", margin: "4px 0" }}>
          Clarity · Communication · Alignment
        </p>

        <nav
          data-testid="footer-links"
          style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 22, margin: "8px 0 4px" }}
        >
          {footerLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              style={{ color: "rgba(255,255,255,0.7)", textDecoration: "none", transition: "color 0.2s" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "white")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.7)")}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <p style={{ color: "rgba(255,255,255,0.45)", margin: "6px 0 0" }}>
          © 2026 MarrsingClause®. All Rights Reserved.
        </p>
        <a
          href="https://marrsinglife.com"
          data-testid="footer-site-link"
          style={{ color: "rgba(255,255,255,0.6)", textDecoration: "none" }}
        >
          marrsinglife.com
        </a>
      </div>
    </footer>
  );
}
